import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    cfsView: {label: "Cash Flow Statement", value: "Cash Flow Statement"}, 
    cfsViewType: {label: "Indirect Method", value: "Indirect Method"},
    cfsSelectedPeriod: "",
    clearFilter: false,
    disableFilter: true,
    cfsLibrartBy: {label: "CFS by Caption", value: "CFS by Caption"},
    disableLibraryFilter: true,
    clearLibraryFilter: false,
    cfsLibraryEditActiveState: false,
    cfsWpEditActiveState: false
}

const cfsSlice = createSlice({
    name: 'CFSSLICE',
    initialState,
    reducers: {
        setCfsViewHandler(state, action) {
            state.cfsView = action.payload;
        },
        setCfsTypeHandler(state, action) {
            state.cfsViewType = action.payload;
        },
        setCfsSelectedPeriod(state, action) {
            state.cfsSelectedPeriod = action.payload;
        },
        setClearFilter(state, action) {
            state.clearFilter = action.payload;
        },
        setDisableClearFilter(state, action) {
            state.disableFilter = action.payload;
        },
        setCfsLibraryBy(state, action) {
            state.cfsLibrartBy = action.payload;
        },
        setDisableLibraryFilter(state, action) {
            state.disableLibraryFilter = action.payload;
        },
        setClearLibraryFilter(state, action) {
            state.clearLibraryFilter = action.payload;
        },
        setCfsLibraryEditActiveState(state, action) {
            state.cfsLibraryEditActiveState = !state.cfsLibraryEditActiveState
        },
        setCfsWpEditAcitveState(state, action) {
            state.cfsWpEditActiveState = !state.cfsWpEditActiveState
        }
    }
});

export const { 
    setCfsViewHandler, 
    setCfsTypeHandler,
    setCfsSelectedPeriod, 
    setClearFilter, 
    setDisableClearFilter, 
    setCfsLibraryBy, 
    setDisableLibraryFilter, 
    setClearLibraryFilter, 
    setCfsLibraryEditActiveState,
    setCfsWpEditAcitveState 
} = cfsSlice.actions;

export default cfsSlice;